import _isString from 'lodash/isString';

/**
 * @module tools/RegTools
 *
 * @description
 * вспомогательный модуль для работы с регулярками и строками, которые будут использоваться как шаблоны
 *
 * @private
 */
class RegTools {

  constructor() {
    this['_toEscape'] = /[|\\{}()[\]^$+*?.]/g;
  }

  /**
  * @memberof module:tools/RegTools
  * @param {string} string - Строка для экранирования
  *
  * @description
  * Делаем экранирование спецсимволов во входной строке, чтобы при дальнейшем использовании в качестве шаблона не ломался парсер регулярок
  *
  * @example
  * RegTools.escape('\[]') -> '\\\[\]'
  */
  escape(string: string) {
    if (!_isString(string)) {
      console.warn('not string: ', string);
      return false;
    }

    return string.replace(this['_toEscape'], '\\$&');
  }
}


export default RegTools;
